module.exports = __webpack_public_path__ + "static/media/preview.934f0c98.webp";